import React from "react";
import PropTypes from "prop-types";
import styles from "./MapPanel.module.scss";

const MapPanel = ({ children }) => {
  return <div className={styles.mapPanel}>{children}</div>;
};

MapPanel.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MapPanel;
